<template>
  <div>
    <v-layout
      mt-4
      justify-center
      v-if="
        products && !products.length && sectors && !sectors.length && !loading
      "
    >
      <h5 class="checkout-h5">Nenhum produto disponível para venda</h5>
    </v-layout>

    <v-radio-group v-model="uniqueSelection">
      <!-- FIRST SECTOR -->
      <v-list
        three-lines
        v-if="firstSectors && firstSectors.length"
        class="sector-list py-0"
      >
        <template v-for="(sector, index) in firstSectors">
          <v-layout
            justify-space-between
            row
            class="product-type-info"
            :style="
              hoverShape &&
              sector.codigo === hoverShape &&
              sector.mapa_coordenadas &&
              sector.mapa_coordenadas.length
                ? 'background-color: rgba(255,255,0,0.1)'
                : ''
            "
            :class="!hasProductAvaiable(sector) ? 'cursor-default' : ''"
            @mouseenter="$store.commit('SET_HOVER_SHAPE', sector.codigo)"
            @mouseleave="$store.commit('SET_HOVER_SHAPE', null)"
            @click="selectSector(sector)"
            :key="sector.codigo"
          >
            <v-flex xs9 sm10 lg10>
              <h3 class="checkout-h3">{{ sector.nome }}</h3>
              <span
                v-if="hasProductAvaiable(sector)"
                class="product-price"
                v-html="rangeByType(sector.products, 'onlyMin', true)"
              >
              </span>
            </v-flex>
            <v-flex shrink>
              <!-- <v-layout align-center justify-center row fill-height v-if="product.encerrado">
            Encerrado
          </v-layout> -->
              <v-layout>
                <v-chip
                  v-if="!hasProductAvaiable(sector)"
                  outline
                  color="#838D9B"
                  >Esgotado</v-chip
                >
                <div v-else class="v-expansion-panel__header__icon">
                  <v-icon class="v-icon material-icons theme--light"
                    >keyboard_arrow_right</v-icon
                  >
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider
            :key="index"
            v-if="index !== sectors.length - 1"
          ></v-divider>
        </template>
      </v-list>
      <v-divider v-if="sectors && sectors.length"></v-divider>
      <single-product-display
        v-if="
          (products && products.length === 1 && Boolean(productsExpanded)) ||
            (products &&
              products.length === 1 &&
              !Boolean(productsExpanded) &&
              cupomCode)
        "
        v-for="(type, i) in products[0]"
        :key="i"
        :type="type"
        :divider="true"
      />
      <v-expansion-panel
        v-if="
          !(
            (products && products.length === 1 && Boolean(productsExpanded)) ||
            (products &&
              products.length === 1 &&
              !Boolean(productsExpanded) &&
              cupomCode)
          )
        "
        v-model="open"
        :expand="Boolean(productsExpanded)"
      >
        <v-expansion-panel-content
          v-if="nameGroups && nameGroups[i] && !nameGroups[i].grupo"
          :style="
            hoverShape &&
            Number(types[0].codigo_produto) === Number(hoverShape) &&
            types[0].mapa_coordenadas &&
            types[0].mapa_coordenadas.length
              ? 'background-color: rgba(255,255,0,0.1)'
              : ''
          "
          :disabled="!rangeByType(types) || !hasProductAvaiableExpansion(types)"
          v-for="(types, i) in products"
          :key="i"
          :class="Boolean(productsExpanded) ? 'hide-header' : ''"
          class="product-expansion-panel"
        >
          <div
            slot="header"
            @mouseenter="
              $store.commit('SET_HOVER_SHAPE', types[0].codigo_produto)
            "
            @mouseleave="$store.commit('SET_HOVER_SHAPE', null)"
            @click="selectPanel(null)"
            class="panel-header"
            v-show="!Boolean(productsExpanded)"
          >
            <div>
              <v-layout
                v-if="nameGroups && nameGroups[i] && nameGroups[i].show"
                mb-3
              >
                <b style="color: #f68d00">{{ nameGroups[i].grupo }}</b>
              </v-layout>
              <h3 class="checkout-h3">
                {{
                  types[0].nome
                    .replace(types[0].nome_grupo, '')
                    .replace('-', '')
                }}
              </h3>
              <h5
                class="checkout-h5 product-range"
                v-if="hasProductAvaiableExpansion(types)"
                :class="
                  types.cupom === 1 ? 'product-range-cupom' : 'product-range'
                "
              >
                {{ rangeByType(types, 'onlyMin') }}
              </h5>
              <div v-if="types[0].observacoes" style="margin: 10px 0;">
                <h4 class="checkout-h4 grey--text pre-white-space">
                  {{
                    toggleMore[i]
                      ? types[0].observacoes
                      : cutString(types[0].observacoes)
                  }}
                </h4>
                <h4
                  v-if="types[0].observacoes.length > 42"
                  class="checkout-h4 primary--text clickable"
                  @click.stop="toggleShowMore(i)"
                >
                  {{ toggleMore[i] ? 'Mostrar menos' : 'Mostrar mais' }}
                </h4>
              </div>
            </div>
            <span
              v-if="totalByProduct(types)"
              dark
              class="panel-header__quantity grey lighten-2"
              >{{ totalByProduct(types) }}</span
            >
            <v-chip
              v-if="!hasProductAvaiableExpansion(types)"
              outline
              class="mt-2"
              color="#838D9B"
              >Esgotado</v-chip
            >

            <v-chip v-else-if="!rangeByType(types)" outline color="#838D9B"
              >Encerrado</v-chip
            >
          </div>
          <v-card>
            <div v-if="maxCartQuantity === 1">
              <single-product-display
                v-for="(type, i) in types"
                :key="i"
                :type="type"
                :divider="i !== types.length - 1"
              />
            </div>
            <product-types
              v-else
              :class="!Boolean(productsExpanded) ? `grey lighten-4` : ''"
              :productTypes="types"
            />
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content
          v-if="
            nameGroups &&
              nameGroups[index] &&
              nameGroups[index].show &&
              nameGroups[index].grupo
          "
          :disabled="group.closed === undefined"
          class="product-expansion-panel group-panel"
          v-for="(group, index) in nameGroups"
          :key="index"
        >
          <div slot="header" class="panel-header">
            <v-layout py-1>
              <b class="checkout-h3 title-group">{{ group.grupo }}</b>
              <v-spacer></v-spacer>
              <v-chip v-if="group.closed === undefined" outline color="#838D9B"
                >Encerrado</v-chip
              >
            </v-layout>
          </div>
          <v-card>
            <v-expansion-panel
              v-model="openChildren"
              :expand="Boolean(productsExpanded)"
            >
              <v-expansion-panel-content
                v-if="types[0].nome_grupo === nameGroups[index].grupo"
                :disabled="!rangeByType(types)"
                v-for="(types, i) in products"
                :key="i"
                :class="Boolean(productsExpanded) ? 'hide-header' : ''"
                class="product-expansion-panel"
              >
                <div
                  v-if="types[0].nome_grupo === nameGroups[index].grupo"
                  slot="header"
                  class="panel-header"
                  v-show="!Boolean(productsExpanded)"
                >
                  <div>
                    <h3 class="checkout-h3">
                      {{
                        types[0].nome
                          .replace(types[0].nome_grupo, '')
                          .replace('-', '')
                      }}
                    </h3>
                    <h5
                      class="checkout-h5 product-range"
                      :class="
                        types.cupom === 1
                          ? 'product-range-cupom'
                          : 'product-range'
                      "
                    >
                      {{ rangeByType(types, 'onlyMin') }}
                    </h5>
                    <div v-if="types[0].observacoes" style="margin: 10px 0;">
                      <h4 class="checkout-h4 grey--text pre-white-space">
                        {{
                          toggleMore[i]
                            ? types[0].observacoes
                            : cutString(types[0].observacoes)
                        }}
                      </h4>
                      <h4
                        v-if="types[0].observacoes.length > 42"
                        class="checkout-h4 primary--text clickable"
                        @click.stop="toggleShowMore(i)"
                      >
                        {{ toggleMore[i] ? 'Mostrar menos' : 'Mostrar mais' }}
                      </h4>
                    </div>
                  </div>
                  <span
                    v-if="totalByProduct(types)"
                    dark
                    class="panel-header__quantity grey lighten-2"
                    >{{ totalByProduct(types) }}</span
                  >
                  <v-chip v-if="!rangeByType(types)" outline color="#838D9B"
                    >Encerrado</v-chip
                  >
                </div>
                <v-card>
                  <div v-if="maxCartQuantity === 1">
                    <single-product-display
                      v-for="(type, i) in types"
                      :key="i"
                      :type="type"
                      :divider="i !== types.length - 1"
                    />
                  </div>
                  <product-types
                    v-else
                    :class="!Boolean(productsExpanded) ? `grey lighten-4` : ''"
                    :productTypes="types"
                  />
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-divider v-if="products && products.length > 1"></v-divider>

      <!-- Last SECTOR -->
      <v-list
        three-lines
        v-if="lastSectors && lastSectors.length"
        class="sector-list py-0"
      >
        <template v-for="(sector, index) in lastSectors">
          <v-layout
            justify-space-between
            row
            class="product-type-info"
            :style="
              hoverShape &&
              sector.codigo === hoverShape &&
              sector.mapa_coordenadas &&
              sector.mapa_coordenadas.length
                ? 'background-color: rgba(255,255,0,0.1)'
                : ''
            "
            :class="!hasProductAvaiable(sector) ? 'cursor-default' : ''"
            @mouseenter="$store.commit('SET_HOVER_SHAPE', sector.codigo)"
            @mouseleave="$store.commit('SET_HOVER_SHAPE', null)"
            @click="selectSector(sector)"
            :key="sector.codigo"
          >
            <v-flex xs9 sm10 lg10>
              <h3 class="checkout-h3">{{ sector.nome.slice(0, -1) }}</h3>
              <span
                v-if="hasProductAvaiable(sector)"
                class="product-price"
                v-html="rangeByType(sector.products, 'onlyMin', true)"
              ></span>
            </v-flex>
            <v-flex shrink>
              <!-- <v-layout align-center justify-center row fill-height v-if="product.encerrado">
            Encerrado
          </v-layout> -->
              <v-layout>
                <v-chip
                  v-if="!hasProductAvaiable(sector)"
                  outline
                  color="#838D9B"
                  >Esgotado</v-chip
                >
                <div v-else class="v-expansion-panel__header__icon">
                  <v-icon class="v-icon material-icons theme--light"
                    >keyboard_arrow_right</v-icon
                  >
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider
            :key="index"
            v-if="index !== sectors.length - 1"
          ></v-divider>
        </template>
      </v-list>
      <v-divider v-if="sectors && sectors.length"></v-divider>
    </v-radio-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductTypes from './ProductTypes';
import SingleProductDisplay from './SingleProductDisplay.vue';

export default {
  components: { ProductTypes, SingleProductDisplay },
  data() {
    return {
      toggleMore: [],
      uniqueSelection: null,
      open: [],
      openChildren: [],
      selectedPanel: null,
    };
  },
  mounted() {
    if (
      this.products &&
      this.products.length === 1 &&
      this.products[0].length === 1 &&
      this.sectors &&
      !this.sectors.length
    ) {
      this.uniqueSelection =
        this.products[0][0].codigo_produto +
        '-' +
        this.products[0][0].codigo_tipo;
    }
    if (this.productsExpanded) {
      this.open = new Array(this.products.length).fill(true);
      this.openChildren = new Array(this.products.length).fill(true);
    }
  },
  computed: {
    ...mapGetters({
      products: 'noSectorProducts',
      sectors: 'sectors',
      loading: 'loading',
      cartProducts: 'cartProducts',
      productsExpanded: 'productsExpanded',
      eventID: 'eventID',
      productsNoGroup: 'productsNoGroup',
      hoverShape: 'hoverShape',
      cupomCode: 'cupomCode',
      eventDetails: 'eventDetails',
    }),

    firstSectors() {
      if (this.sectors && this.sectors.length) {
        return this.sectors.filter(s => !s.nome.endsWith('.'));
      }

      return [];
    },

    lastSectors() {
      if (this.sectors && this.sectors.length) {
        return this.sectors.filter(s => s.nome.endsWith('.'));
      }

      return [];
    },

    prevSelectedSector() {
      return this.$store.getters.selectedSector;
    },
    maxCartQuantity() {
      return this.$store.getters.maxProductsCart;
    },
    nameGroups() {
      let array = [];
      this.products.forEach((p, index) => {
        if (
          array.find(a => {
            return p[0].nome_grupo === a.grupo;
          })
        ) {
          array.push({ grupo: p[0].nome_grupo, show: false });
        } else {
          array.push({ grupo: p[0].nome_grupo, show: true });
        }
      });
      let mappedArray = array.map(a => {
        return {
          ...a,
          closed: this.productsNoGroup
            .filter(p => {
              return a.grupo === p.nome_grupo;
            })
            .find(p => {
              if (p.encerrado) return false;
              if (!p.encerrado) return true;
            }),
        };
      });
      return mappedArray;
    },
    groups() {
      let arr = [];
      this.products.forEach(p => {
        arr.push([p]);
      });
      if (!arr) return [];
      return arr;
    },
  },
  created() {
    this.toggleMore = this.products.map(product => false);
  },
  methods: {
    selectPanel(index) {
      if (!index) this.selectedPanel = null;
      if (index === this.selectedPanel) this.selectedPanel = null;
      else this.selectedPanel = index;
    },
    checkEspecialPrice(productTypes) {
      let hasEspecialPrice = null;
      productTypes.forEach(type => {
        if (type.cupom === 1) hasEspecialPrice = true;
      });
      if (hasEspecialPrice) return 'product-range-cupom';
      else return 'product-range';
    },
    toggleShowMore(i) {
      this.$set(this.toggleMore, i, !this.toggleMore[i]);
    },
    selectSector(selectedSector) {
      if (this.hasProductAvaiable(selectedSector)) {
        selectedSector.priceRange = this.rangeByType(selectedSector.products);
        if (
          this.prevSelectedSector &&
          this.prevSelectedSector !== selectedSector &&
          this.cartProducts &&
          this.cartProducts.length
        ) {
          this.$store.dispatch('setResetSector', true);
          this.$store.dispatch('setTempSelectedSector', selectedSector);
        } else {
          this.$store.dispatch('setSelectedSector', selectedSector);
        }
      }
    },
    totalByProduct(productTypes) {
      return productTypes.reduce(
        (total, element) => element.quantidade + total,
        0
      );
    },
    rangeByType(productTypes, onlyMin, sectors) {
      let min = Number.MAX_SAFE_INTEGER;
      let minTax = Number.MAX_SAFE_INTEGER;
      let minBatch = Number.MIN_SAFE_INTEGER;
      let max = Number.MIN_SAFE_INTEGER;
      let maxTax = Number.MIN_SAFE_INTEGER;
      let coupon = false;

      productTypes.forEach(type => {
        if (!type.encerrado) {
          const value = type.valor + type.valor_conveniencia;
          if (min > value) {
            min = value;
            if (sectors) {
              min = type.valor;
              minTax = type.valor_conveniencia;
              minBatch = type.lote_atual;
              coupon = type.cupom;
            }
          }

          if (max < value) {
            max = value;
            if (sectors) {
              max = type.valor;
              maxTax = type.valor_conveniencia;
            }
          }
        }
      });

      if (max === Number.MIN_SAFE_INTEGER && min === Number.MAX_SAFE_INTEGER) {
        max = 0;
        min = 0;
        return '';
      }
      min = this.$options.filters.currency(min * 100);
      max = this.$options.filters.currency(max * 100);
      minTax = this.$options.filters.currency(minTax * 100);
      maxTax = this.$options.filters.currency(maxTax * 100);

      if (sectors) {
        const value = min;
        const tax = minTax ? ` + ${minTax} taxa` : '';
        const lote = ` (Lote ${minBatch})`;
        if (coupon === 0)
          return `<span style="font-size: 16px; color: #1976d2">${
            min !== max ? 'A partir de ' : ''
          }${value}</span>${tax}${
            this.eventDetails && this.eventDetails.exibir_lote ? lote : ''
          }`;
        else
          return `<span style="font-size: 16px; color: #00A65A">${
            min !== max ? 'A partir de ' : ''
          }${value}</span>${tax}${
            this.eventDetails && this.eventDetails.exibir_lote ? lote : ''
          }`;
      } else if (onlyMin) return min !== max ? `A partir de ${min}` : min;
      else return min !== max ? `${min} - ${max}` : min;
    },
    cutString(data) {
      if (data.length > 42) return `${data.substring(0, 39)}...`;
      return data;
    },
    add(product) {
      product.haveSeat = false;
      if (product.quantidade === 0 && product.quantidade_minima > 1) {
        for (var i = 0; i < product.quantidade_minima; i++) {
          this.$store.dispatch('addCartProduct', product);
          this.$store.dispatch('incrementProductsQuantity', product);
        }
      } else {
        this.$store.dispatch('addCartProduct', product);
        this.$store.dispatch('incrementProductsQuantity', product);
      }
    },
    remove(product) {
      product.haveSeat = false;
      if (product.quantidade === product.quantidade_minima) {
        for (var i = 0; i < product.quantidade_minima; i++) {
          this.$store.dispatch('removeCartProduct', product);
          this.$store.dispatch('decrementProductsQuantity', product);
        }
      } else {
        this.$store.dispatch('removeCartProduct', product);
        this.$store.dispatch('decrementProductsQuantity', product);
      }
    },

    hasProductAvaiable(sector) {
      const findedProduct = sector.products.find(p => !p.esgotado);

      return !!findedProduct;
    },

    hasProductAvaiableExpansion(item) {
      return item.find(p => {
        return !p.esgotado;
      });
    },
  },
  watch: {
    uniqueSelection(v) {
      if (v) {
        let product = parseInt(v.split('-')[0]);
        let type = parseInt(v.split('-')[1]);
        let selected = this.products
          .flat(Infinity)
          .find(t => t.codigo_produto === product && t.codigo_tipo === type);
        for (let i = 0; i < this.cartProducts.length; i++) {
          this.remove(
            this.products
              .flat(Infinity)
              .find(
                t =>
                  this.cartProducts[i][0].codigo_produto === t.codigo_produto &&
                  this.cartProducts[i][0].codigo_tipo === t.codigo_tipo
              )
          );
        }

        if (selected && this.maxCartQuantity === 1) this.add(selected);
      }
    },
  },
};
</script>

<style lang="stylus">
@import '~@/assets/product/productsPanel.styl'
@import "~@/assets/product/productTypes.styl"
</style>

<style>
.hide-header .v-expansion-panel__header {
  display: none;
}

.v-expansion-panel__container--active
  .v-expansion-panel__header
  .panel-header
  .layout
  .title-group {
  color: #f68d00 !important;
}

.product-expansion-panel .v-expansion-panel__header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.cursor-default {
  cursor: default;
}
</style>
